import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../../OpenTabsContext";
import { hmLightTheme } from "../../themes/hmTheme";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import useNotify from "../../unit/useNotify";
const TableCellRight = styled(TableCell)({ textAlign: "right" });
const CustomSummaryApplicationList = ({ ...props }) => {
  const { openGlobalTabs } = useContext(OpenTabsContext);
  const navigate = useNavigate();
  const { successNotify, errorNotify, infoNotify } = useNotify();

  const userId = props.userId;
  const applications = props.applications;
  if (applications == undefined || applications == null) {
    return <Typography>No Applications Data</Typography>;
  }

  const ApplicationIDLinkField = ({ ...props }) => {
    const { paramAppId, loannum } = props;
    const handleClick = (id: any, loannum: any) => {
      if (openGlobalTabs.length >= 6) {
        if (openGlobalTabs.includes("app-" + id + "-" + loannum)) {
          navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
        } else {
          errorNotify("Cannot open more than 6 tabs.");
          return false;
        }
      } else {
        navigate(`/applicationSummary/` + id + "?loannum=" + loannum);
      }
    };

    return (
      <Link
        component="span"
        onClick={() => handleClick(paramAppId, loannum)}
        sx={{
          cursor: "pointer",
          textDecoration: "none",
          fontFaimily: hmLightTheme?.palette?.numberFontFamily,
          "&.RaLink-link": {
            color: "#1976d2",
          },
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {paramAppId}
      </Link>
    );
  };
  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable stickyHeader id="table-customer-summary-application-list">
          <TableHead>
            <TableRow>
              <TableCell className="hm-table-header">App #</TableCell>
              {/* <TableCell sx={{ minWidth: "120px" }}>
              Date <br />
              Started
            </TableCell> */}
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Date <br />
                Submitted
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Date <br />
                Notified
              </TableCell>
              <TableCell className="hm-table-header">Institution</TableCell>
              <TableCell className="hm-table-header">Product</TableCell>
              <TableCell className="hm-table-header">Status</TableCell>
              <TableCell className="hm-table-header">Decision</TableCell>
              <TableCell className="hm-table-header" align="right">
                Amount Applied
              </TableCell>
              <TableCell className="hm-table-header" align="right">
                Amount Approved
              </TableCell>
              <TableCell className="hm-table-header">Referral</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {applications == undefined ||
            applications.length == 0 ||
            applications == null ? (
              <TableRow>
                <TableCell colSpan={8}>No Applications </TableCell>
              </TableRow>
            ) : (
              applications.map((item: any) => (
                <TableRow key={item.iId + " " + item.dtInsert}>
                  <TableCell>
                    {item?.sStatus == "Incomplete" ? (
                      <>{item?.iApplicationId}</>
                    ) : (
                      <ApplicationIDLinkField
                        paramAppId={item.iApplicationId}
                        loannum={item.sLoanNum}
                      />
                    )}
                  </TableCell>
                  {/* <TableCell>{formatDate(item.dtInsert)}</TableCell> */}
                  <TableCell>{formatDate(item.dtDocusignComplete)}</TableCell>
                  <TableCell>{formatDate(item.lastexecTime)}</TableCell>
                  <TableCell
                    sx={{
                      minWidth: "120px",
                      wordBreak: "break-word",
                      overflowX: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      maxWidth: "200px",
                    }}
                  >
                    {item.sBankName}
                  </TableCell>
                  <TableCell
                    sx={{
                      minWidth: "120px",
                      wordBreak: "break-word",
                      overflowX: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      maxWidth: "200px",
                    }}
                  >
                    {item.sProductName}
                  </TableCell>
                  <TableCell>{item.sStatus}</TableCell>
                  <TableCell>{item.decision}</TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(
                      item.iAmount && item.iAmount != "0.00"
                        ? item.iAmount
                        : item.reviewAmount
                    )}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.reviewAmount)}
                  </TableCell>
                  <TableCell
                    sx={{
                      minWidth: "120px",
                      wordBreak: "break-word",
                      overflowX: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      maxWidth: "200px",
                    }}
                  >
                    <Typography>{item.counselor_agency}</Typography>
                    <Typography>{item.counselor_name}</Typography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default CustomSummaryApplicationList;
